import { ValidationErrorType } from "processEditor/model/ValidationData";
import { ITriggerValidatorProps } from "./validateConditionalTriggers";
import { Triggers } from "processEditor/model/ITriggerData";
import { addNameValidationError } from "../ValidateProcess";

export default function ({ triggers, validationErrors: existingErrors }: ITriggerValidatorProps) {
    const apiTriggers = triggers.filter((e) => e?.selectedTypeId === Triggers.HttpApiTrigger.triggerType);
    if (apiTriggers.length > 1) {
        // only one api trigger is allowed, put an error on each apiTrigger:
        for (const trigger of apiTriggers) {
            addNameValidationError(existingErrors, ValidationErrorType.DuplicateApiTrigger, trigger?.id);
        }
    }
}